class DeliveryEstimations extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    const from = this.dataset.from
    const to = this.dataset.to
    const status = this.dataset.status
    const locale = this.dataset.languageKey || 'en'

    if (status !== 'Active' || !from || !to) return

    const dateFrom = this.getEstimatedDate(from, locale)
    const dateTo = this.getEstimatedDate(to, locale)

    const estimateText = `${dateFrom} - ${dateTo}`
    const outputEl = this.els.days.element
    if (outputEl) outputEl.textContent = estimateText

    if (dateFrom && dateTo) {
      requestAnimationFrame(() => {
        outputEl.setAttribute('aria-hidden', false)
      })
    }
  }

  getEstimatedDate (estimation, locale) {
    if (!estimation) return ''

    const currentDate = new Date()
    const currentHour = currentDate.getHours()
    const isAfterCutoff = currentHour >= 15
    const daysToAdd = Number(estimation) + (isAfterCutoff ? 1 : 0)

    const estimatedDate = this.addWorkDays(
      currentDate,
      daysToAdd,
      false, // includeSaturday
      false, // includeSunday
      true, // addAdditionalDayForSundays
    )

    const formattedDate = estimatedDate.toLocaleDateString(locale, {
      month: 'short',
      day: 'numeric',
    })

    return formattedDate
  }

  addWorkDays (
    startDate,
    days,
    includeSaturday,
    includeSunday,
    addAdditionalDayForSundays,
  ) {
    const dow = startDate.getDay()
    let daysToAdd = days

    if (addAdditionalDayForSundays && dow === 0) daysToAdd++

    const weekendDeliveryDays =
      includeSaturday && includeSunday
        ? 2
        : includeSaturday || includeSunday
          ? 1
          : 0

    const shouldCalculateWeekends =
      (!includeSaturday && dow + daysToAdd >= 6) ||
      (includeSaturday && dow + daysToAdd >= 7)

    if (shouldCalculateWeekends) {
      const remainingWorkDays = daysToAdd - (5 + weekendDeliveryDays - dow)
      daysToAdd += 2 - weekendDeliveryDays

      if (remainingWorkDays > 5 + weekendDeliveryDays) {
        const fullWeeks = Math.floor(
          remainingWorkDays / (5 + weekendDeliveryDays),
        )
        daysToAdd += (2 - weekendDeliveryDays) * fullWeeks

        if (remainingWorkDays % (5 + weekendDeliveryDays) === 0) {
          daysToAdd -= 2 - weekendDeliveryDays
        }
      }
    }

    startDate.setDate(startDate.getDate() + daysToAdd)
    return startDate
  }
}

if (!customElements.get('delivery-estimations')) {
  customElements.define('delivery-estimations', DeliveryEstimations)
}
